import PropTypes from "prop-types";

// material-ui
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

// projects import
import CloseIconButton from "./icons/CloseIconButton";

const PopUpModal = ({
  open,
  handleCloseDialog,
  title,
  content,
  showCloseIcon,
  maxWidth,
}) => (
  <Dialog
    open={open}
    sx={{
      "&>div:nth-of-type(3)": {
        "&>div": {
          maxWidth: maxWidth || 1000,
        },
      },
    }}
    fullWidth
  >
    <DialogTitle
      display="flex"
      justifyContent={title ? "space-between" : "flex-end"}
      alignItems="center"
    >
      {title}
      {showCloseIcon && (
        <CloseIconButton color="inherit" onClick={handleCloseDialog} />
      )}
    </DialogTitle>

    {/* DialogContent handles scrolling automatically */}
    <DialogContent sx={{ maxHeight: "70vh", overflowY: "auto" }}>
      {content}
    </DialogContent>
  </Dialog>
);

PopUpModal.defaultProps = {
  showCloseIcon: true,
};

PopUpModal.propTypes = {
  open: PropTypes.bool,
  handleCloseDialog: PropTypes.func,
  title: PropTypes.string,
  content: PropTypes.element,
  showCloseIcon: PropTypes.bool,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default PopUpModal;
